module.exports = __webpack_public_path__ + "static/media/img41.7daf74a9.jpg";